const trataDadosFiscaisProduto = (fiscal) => {
  if (!fiscal) {
    return null;
  }

  let aliquotaAtualizada = JSON.parse(JSON.stringify(fiscal));

  const isNovoRegistro = !aliquotaAtualizada.id;

  if (isNovoRegistro) {
    aliquotaAtualizada.id = null;

    if (aliquotaAtualizada.ipi) {
      aliquotaAtualizada.ipi.id = null;
    }
    if (aliquotaAtualizada.icms) {
      aliquotaAtualizada.icms.id = null;
    }
  }

  if (aliquotaAtualizada.tipoUnidadeMedida === 'VAZIO') {
    aliquotaAtualizada.tipoUnidadeMedida = 'UNIDADE';
  }

  if (fiscal?.codigoNCM?.id) {
    aliquotaAtualizada.codigoNCM = fiscal.codigoNCM.id;
  } else {
    aliquotaAtualizada.codigoNCM = null;
  }

  if (fiscal?.cest?.id) {
    aliquotaAtualizada.cest = fiscal.cest.id;
  } else {
    aliquotaAtualizada.cest = null;
  }

  if (fiscal?.cfop?.id) {
    aliquotaAtualizada.cfop = fiscal.cfop.id;
  } else {
    aliquotaAtualizada.cfop = null;
  }

  if (fiscal?.origemProduto?.id) {
    aliquotaAtualizada.origemProduto = fiscal.origemProduto.id;
  } else {
    aliquotaAtualizada.origemProduto = null;
  }

  if (fiscal?.ipi?.situacaoTributaria?.id) {
    aliquotaAtualizada.ipi.situacaoTributaria = fiscal.ipi.situacaoTributaria.id;
  } else {
    aliquotaAtualizada.ipi = null;
  }

  if (fiscal?.icms?.situacaoTributaria?.id) {
    aliquotaAtualizada.icms.situacaoTributaria = fiscal.icms.situacaoTributaria?.id;
  } else {
    aliquotaAtualizada.icms = null;
  }

  if (aliquotaAtualizada.icms) {
    if (fiscal?.icms?.motivoDesoneracao?.id) {
      aliquotaAtualizada.icms.motivoDesoneracao = fiscal.icms.motivoDesoneracao.id;
    } else {
      aliquotaAtualizada.icms.motivoDesoneracao = null;
    }

    if (fiscal?.icms?.ufIcmsStDevido?.id) {
      aliquotaAtualizada.icms.ufIcmsStDevido = fiscal.icms.ufIcmsStDevido.id;
    } else {
      aliquotaAtualizada.icms.ufIcmsStDevido = null;
    }
  }

  if (fiscal.cstSituacaoTributaria) {
    aliquotaAtualizada.cstSituacaoTributariaId = fiscal?.cstSituacaoTributaria?.id;
  }

  if (fiscal.cstClassificacaoTributaria) {
    aliquotaAtualizada.cstClassificacaoTributariaId = fiscal?.cstClassificacaoTributaria?.id;
  }

  return aliquotaAtualizada;
};

export { trataDadosFiscaisProduto };
